module.exports = __webpack_public_path__ + "static/media/BoxPlotQ6_2.d32e51bc.svg";